import { render, staticRenderFns } from "./charidyToGo.vue?vue&type=template&id=ed3598c6&"
import script from "./charidyToGo.vue?vue&type=script&lang=js&"
export * from "./charidyToGo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports